export class OfferSearch {
    location: boolean;
    zipCode?: string;
    radius: number;
}
